import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { makeMenuLink } from '../ShoppingCartUtils/Helpers.js';


/* Category Name Tile - Simple Child Component */
class CategoryNameTile extends Component {
    render() {
        const href = makeMenuLink(this.props.id, this.props.name, (this.props.path ? this.props.path : '/categories/'));
        return (
            <div className="course-category__name__wrapper col-sm-6 col-md-4 col-lg-2">
                <a className="course-category__name__tile trans18s" href={href}
                    aria-label={ReactHtmlParser(this.props.name) + ((this.props.path === '/categories/' || !this.props.path) ? ' Category' : ' Brand')}>
                {ReactHtmlParser(this.props.name)}</a>
            </div >
        );
    }
}

export default CategoryNameTile;